import { z } from "zod";
export const oauthCompleteRequestSchema = z.object({
    query: z.string().min(1),
});
export const OAuthCompleteResponseSchema = z.object({
    redirectTo: z.url(),
});
export const OAuthClientInfoSchema = z.object({
    clientName: z.string().nullable(),
    clientUri: z.string().nullable(),
    redirectUris: z.array(z.string()),
});
